<div *ngIf="block" class="d-flex flex-wrap flex-md-nowrap card-event" [ngClass]="{'p-3': isEvent}">
    <div class="box-left col-12 col-md-5 position-relative">
        <img loading="lazy" class="w-100" *ngIf="block.field_immagine" [src]="setImage(block.field_immagine)"
            [alt]="setAltImage(block.field_immagine)">
        <img loading="lazy" class="w-100" *ngIf="block.field_immagine_importata" [src]="this.domainWebsite + block.field_immagine_importata"
            alt="Event | Lumsa">
        <img loading="lazy" class="w-100" *ngIf="!block.field_immagine && !block.field_immagine_importata"
            src="../../../../../../assets/images/rectangle_gradient.png" alt="'Event | Lumsa'">
        <div *ngIf="block.field_tipologia_evento" class="position-absolute text-white box-left__container-badge">
            <p class="m-0 ls-label-small-semibold text-uppercase">{{ block.field_tipologia_evento }}</p>
        </div>
        <div class="position-absolute text-white box-left__title d-flex flex-column justify-content-between">
            <div *ngIf="block.content_type === 'Archivio Evento'">
                <div *ngIf="date" class="box-left__title__date">
                    <p *ngIf="date.inizio && date.fine" class="m-0 box-left__title__date__text ls-label-large">
                        {{"BLOCK.SAMPLE_EVENT_SMALL.FROM" | translate}}</p>
                    <p *ngIf="date.inizio" [attr.role]="'heading'"
                        class="m-0 box-left__title__date__month text-garamond ls-label-xl-large text-uppercase">
                        {{ date.inizio | localizedDate: 'dd MMM YY' }}
                    </p>
                    <ng-container *ngIf="date.fine && (date.inizio !== date.fine)">
                        <p class="m-0 box-left__title__date__text ls-label-large">
                            {{"BLOCK.SAMPLE_EVENT_SMALL.TO" | translate}}</p>
                        <p class="m-0 box-left__title__date__month text-garamond ls-label-xl-large text-uppercase" [attr.role]="'heading'">
                            {{ date.fine | localizedDate: 'dd MMM YY' }}
                        </p>
                    </ng-container>
                </div>
            </div>
            <div *ngIf="block.field_tipologia_evento === 'In presenza' || block.field_tipologia_evento === 'In presenza/Online'">
                <div *ngIf="date" class="box-left__title__date">
                    <p *ngIf="date.inizio && date.fine" class="m-0 box-left__title__date__text ls-label-large">
                        {{"BLOCK.SAMPLE_EVENT_SMALL.FROM" | translate}}</p>
                    <p *ngIf="date.inizio" [attr.role]="'heading'"
                        class="m-0 box-left__title__date__month text-garamond ls-label-xl-large text-uppercase">
                        {{ date.inizio | localizedDate: 'dd MMM YY' }}
                    </p>
                    <ng-container *ngIf="date.fine && (date.inizio !== date.fine)">
                        <p class="m-0 box-left__title__date__text ls-label-large">
                            {{"BLOCK.SAMPLE_EVENT_SMALL.TO" | translate}}</p>
                        <p class="m-0 box-left__title__date__month text-garamond ls-label-xl-large text-uppercase" [attr.role]="'heading'">
                            {{ date.fine | localizedDate: 'dd MMM YY' }}
                        </p>
                    </ng-container>
                </div>
                <div class="box-left__title__hours">
                    <p *ngIf="block.field_orario_inizio && block.field_orario_fine" class="m-0 ls-p">
                        {{"BLOCK.SAMPLE_EVENT_SMALL.FROM_HOUR" | translate}} {{ block.field_orario_inizio }}
                        {{"BLOCK.SAMPLE_EVENT_SMALL.TO_HOUR" | translate}} {{ block.field_orario_fine }}
                    </p>
                </div>
            </div>
            <div *ngIf="block.field_tipologia_evento === 'Online'">
                <div *ngIf="date" class="box-left__title__date">
                    <p *ngIf="date.inizio" [attr.role]="'heading'"
                        class="m-0 box-left__title__date__month text-garamond ls-label-xl-large text-uppercase">
                        {{ date.inizio | localizedDate: 'dd MMM YY' }}
                    </p>
                </div>
                <div class="box-left__title__hours">
                    <p *ngIf="block.field_orario_inizio && block.field_orario_fine" class="m-0 ls-p">
                        {{"BLOCK.SAMPLE_EVENT_SMALL.FROM_HOUR" | translate}} {{ block.field_orario_inizio }}
                        {{"BLOCK.SAMPLE_EVENT_SMALL.TO_HOUR" | translate}} {{ block.field_orario_fine }}
                    </p>
                </div>
            </div>
        </div>
        <div *ngIf="block.field_nome_location" class="box-left__location position-absolute">
            <p class="m-0 ls-label-large-semibold" [innerHTML]="block.field_nome_location"></p>
        </div>
    </div>
    <div class="d-flex flex-column justify-content-between col-12 col-md-7 ms-md-2 box-right">
        <div>
            <p *ngIf="setLabelCategorySmall(block.field_tassonomia_area_universita)"
                class="ls-label-small-semibold  box-right__category text-neutral-60 text-uppercase">
                {{ setLabelCategorySmall(block.field_tassonomia_area_universita) }}
            </p>
            <a *ngIf="setTitle(block.field_titolo) && !isLinkEsternal"
                [routerLink]="navigationService.splitUrlRouterLink(setTitle(block.field_titolo).link).path" [queryParams]="navigationService.splitUrlRouterLink(setTitle(block.field_titolo).link).queryParams">
                <p class="ls-h3-item-title box-right__text cursor-pointer text-brand-10" [innerHTML]="setTitle(block.field_titolo).title"></p>
            </a>
            <a *ngIf="setTitle(block.field_titolo) && isLinkEsternal" [href]="setTitle(block.field_titolo).link">
                <p class="ls-h3-item-title box-right__text cursor-pointer text-brand-10" [innerHTML]="setTitle(block.field_titolo).title"></p>
            </a>
        </div>
        <a *ngIf="setTitle(block.field_titolo) && !isLinkEsternal" [routerLink]="navigationService.splitUrlRouterLink(setTitle(block.field_titolo).link).path" [queryParams]="navigationService.splitUrlRouterLink(setTitle(block.field_titolo).link).queryParams">
            <div class="m-0 box-right__cta line-discover-with-icon">
                <p class="ls-label-medium-semibold text-brand-40 text-uppercase text-brand-10">{{"FIND_OUT" | translate}}</p>
                <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
            </div>
        </a>
        <a *ngIf="setTitle(block.field_titolo) && isLinkEsternal" [href]="setTitle(block.field_titolo).link">
            <div class="m-0 box-right__cta line-discover-with-icon">
                <p class="ls-label-medium-semibold text-brand-40 text-uppercase text-brand-10">{{"FIND_OUT" | translate}}</p>
                <i class="fa-solid fa-arrow-right text-brand-40 pb-4" aria-hidden="true"></i>
            </div>
        </a>
    </div>
</div>
<!-- STAMPA -->
<div *ngIf="block" class="card-event-no-print w-100">
    <div class="image">
        <img loading="lazy" class="w-100" *ngIf="block.field_immagine" [src]="setImage(block.field_immagine)"
        [alt]="setAltImage(block.field_immagine)">
        <img loading="lazy" class="w-100" *ngIf="block.field_immagine_importata" [src]="this.domainWebsite + block.field_immagine_importata"
            alt="Event | Lumsa">
        <img loading="lazy" class="w-100" *ngIf="!block.field_immagine && !block.field_immagine_importata"
            src="../../../../../../assets/images/rectangle_gradient.png" alt="'Event | Lumsa'">
    </div>
    <div>
        <p *ngIf="setTitle(block.field_titolo)" class="ls-h3-item-title" [innerHTML]="setTitle(block.field_titolo).title"></p>
        <p *ngIf="setLabelCategorySmall(block.field_tassonomia_area_universita)" class="ls-label-small-semibold text-neutral-60 text-uppercase">
            {{ setLabelCategorySmall(block.field_tassonomia_area_universita) }}
        </p>
    </div>
    <div>
        <div *ngIf="block.field_tipologia_evento" class="text-brand-10">
            <p class="m-0 ls-label-small-semibold text-uppercase">{{ block.field_tipologia_evento }}</p>
        </div>
        <div>
            <div class="">
                <div *ngIf="block.content_type === 'Archivio Evento'">
                    <div *ngIf="date" class="text-brand-10">
                        <p *ngIf="date.inizio" class="m-0 box-left__title__date__text ls-label-large text-uppercase">
                            <span *ngIf="date.inizio && date.fine">{{"BLOCK.SAMPLE_EVENT_SMALL.FROM" | translate}}</span> {{ date.inizio | localizedDate: 'dd MMM YY' }}
                        </p>
                        <p *ngIf="date.fine" class="m-0 box-left__title__date__text ls-label-large text-uppercase">
                            {{"BLOCK.SAMPLE_EVENT_SMALL.TO" | translate}} {{ date.fine | localizedDate: 'dd MMM YY' }}
                        </p>
                    </div>
                </div>
                <div *ngIf="block.field_tipologia_evento === 'In presenza' || block.field_tipologia_evento === 'In presenza/Online'">
                    <div *ngIf="date" class="text-brand-10">
                        <p *ngIf="date.inizio" class="m-0 box-left__title__date__text ls-label-large text-uppercase">
                            <span *ngIf="date.inizio && date.fine">{{"BLOCK.SAMPLE_EVENT_SMALL.FROM" | translate}}</span> {{ date.inizio | localizedDate: 'dd MMM YY' }}
                        </p>
                        <p *ngIf="date.fine" class="m-0 box-left__title__date__text ls-label-large text-uppercase">
                            {{"BLOCK.SAMPLE_EVENT_SMALL.TO" | translate}} {{ date.fine | localizedDate: 'dd MMM YY' }}
                        </p>
                    </div>
                    <div class="text-brand-10">
                        <p *ngIf="block.field_orario_inizio && block.field_orario_fine" class="m-0 ls-p">
                            {{"BLOCK.SAMPLE_EVENT_SMALL.FROM_HOUR" | translate}} {{ block.field_orario_inizio }}
                            {{"BLOCK.SAMPLE_EVENT_SMALL.TO_HOUR" | translate}} {{ block.field_orario_fine }}
                        </p>
                    </div>
                </div>
                <div *ngIf="block.field_tipologia_evento === 'Online'">
                    <div *ngIf="date" class="text-brand-10">
                        <p *ngIf="date.inizio" [attr.role]="'heading'"
                            class="m-0 box-left__title__date__month text-garamond ls-label-xl-large text-uppercase">
                            {{ date.inizio | localizedDate: 'dd MMM YY' }}
                        </p>
                    </div>
                    <div class="text-brand-10">
                        <p *ngIf="block.field_orario_inizio && block.field_orario_fine" class="m-0 ls-p">
                            {{"BLOCK.SAMPLE_EVENT_SMALL.FROM_HOUR" | translate}} {{ block.field_orario_inizio }}
                            {{"BLOCK.SAMPLE_EVENT_SMALL.TO_HOUR" | translate}} {{ block.field_orario_fine }}
                        </p>
                    </div>
                </div>
            </div>
            <div *ngIf="block.field_nome_location" class="text-brand-10">
                <p class="m-0 ls-label-large-semibold" [innerHTML]="block.field_nome_location"></p>
            </div>
        </div>
    </div>
</div>